export default (state, claims) => ({ claims });
